// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoCard {
  cursor: pointer;
  position: relative;
}
.VideoCard .VideoCard-image {
  position: relative;
  margin: 0 0 8px;
}
.VideoCard .VideoCard-image.tooltipped::before {
  top: 130px;
}
.VideoCard .VideoCard-image.tooltipped::after {
  top: 136px;
}
.VideoCard .VideoCard-image .VideoCard-live-ads-badges-with-remove {
  top: 7px !important;
  right: 31px !important;
}
.VideoCard .VideoCard-image .VideoCard-live-ads-badges-wrapper {
  display: flex;
  position: absolute;
  z-index: 1;
  top: 8px;
  right: 8px;
}
.VideoCard .VideoCard-image .VideoCard-live-ads-badges-wrapper .LivePostTag {
  margin-left: 5px;
}
.VideoCard .VideoCard-image .VideoCard-live-ads-badges-wrapper .YellowBadge-customStyle {
  display: flex;
  align-items: center;
  justify-content: center;
}
.VideoCard .VideoCard-image .VideoCard-live-ads-badges-wrapper .YellowBadge-customStyle svg path {
  transform: translateX(20%);
}
.VideoCard .VideoCard-image .thumbnail-component-container {
  overflow: hidden;
  border-radius: 8px;
  height: 173px;
  background-color: var(--gray_insights3);
}
.VideoCard .VideoCard-image .thumbnail-component-container img {
  display: block;
  object-fit: cover;
  transition: all 0.5s ease;
  filter: brightness(80%);
}
.VideoCard .VideoCard-image .thumbnail-component-container img:hover {
  filter: initial;
}
.VideoCard .VideoCard-image .checkbox {
  position: absolute;
  z-index: 1;
  top: 8px;
  left: 8px;
  display: none;
}
.VideoCard .VideoCard-image div.checkbox[class*=dist_checked] {
  display: flex;
}
.VideoCard .VideoCard-image:hover .checkbox {
  display: flex;
}
.VideoCard .VideoCard-image:hover .remove-video {
  display: block;
}
.VideoCard .VideoCard-image > .remove-video {
  position: absolute;
  z-index: 1;
  top: 8px;
  right: 8px;
  display: none;
}
.VideoCard .VideoCard-image > .remove-video svg path {
  fill: var(--base_color1);
}
.VideoCard .VideoCard-provider {
  position: absolute;
  z-index: 1;
  bottom: 8px;
  right: 8px;
  height: 24px;
  width: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.VideoCard .VideoCard-provider [class^=dist_providerIcon] {
  padding: 4px 4px;
  border: 1px solid var(--base_color2);
}
.VideoCard .VideoCard-info-grid {
  position: relative;
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto auto;
  grid-column-gap: 8px;
}
.VideoCard .VideoCard-creator-thumb {
  border-radius: 100%;
  border: 1px solid var(--gray_light2);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: block;
  overflow: hidden;
}
.VideoCard .VideoCard-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: var(--primary_dark2);
  margin: 0 0 12px;
  line-height: 20px;
  font-size: 14px;
}
.VideoCard .CreatorCardOnHover {
  position: static;
  position: initial;
}
.VideoCard .CreatorCardOnHover .CreatorCardOnHover-popover {
  top: auto;
  bottom: 95%;
  width: calc(100% - 16px);
  left: 8px;
  padding: 0 0 8px;
}
.VideoCard .VideoCard-publishedAt {
  font-size: 10px;
  color: var(--gray_dark1);
  line-height: 15px;
}
.VideoCard .VideoCard-TopicListSmall {
  margin: 7px 0 0;
}
.VideoCard .VideoCard-TopicListSmall h6 {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 150px;
  white-space: nowrap;
}
.VideoCard .VideoCard-numbers {
  text-align: center;
}
.VideoCard .VideoCard-numbers strong {
  display: block;
  font-weight: 600;
  font-size: 12px;
  color: var(--gray_dark2);
  line-height: 20px;
  height: 20px;
}
.VideoCard .VideoCard-numbers span {
  display: block;
  font-size: 12px;
  color: var(--gray_dark1);
  line-height: 15px;
}
.VideoCard .VideoCard-views {
  margin: 0 4px 0 0;
}
.VideoCard .VideoCard-info {
  min-height: 109px;
  padding: 0px 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/VideoCard/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,eAAA;AACJ;AACI;EACE,UAAA;AACN;AAEI;EACE,UAAA;AAAN;AAGI;EACE,mBAAA;EACA,sBAAA;AADN;AAII;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAFN;AAIM;EACE,gBAAA;AAFR;AAKM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAHR;AAMU;EACE,0BAAA;AAJZ;AAUI;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;AARN;AAUM;EACE,cAAA;EACA,iBAAA;EACA,yBAAA;EAEA,uBAAA;AATR;AAWQ;EACE,eAAA;AATV;AAcI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AAZN;AAeI;EACE,aAAA;AAbN;AAiBM;EACE,aAAA;AAfR;AAkBM;EACE,cAAA;AAhBR;AAoBI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;AAlBN;AAqBQ;EACE,wBAAA;AAnBV;AAyBE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAvBJ;AAyBI;EACE,gBAAA;EACA,oCAAA;AAvBN;AA2BE;EACE,kBAAA;EACA,aAAA;EACA,oDAAA;EACA,oBAAA;AAzBJ;AA4BE;EACE,mBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AA1BJ;AA6BE;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EAEA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA5BJ;AA+BE;EACE,gBAAA;EAAA,iBAAA;AA7BJ;AA+BI;EACE,SAAA;EACA,WAAA;EACA,wBAAA;EACA,SAAA;EACA,gBAAA;AA7BN;AAiCE;EACE,eAAA;EACA,wBAAA;EACA,iBAAA;AA/BJ;AAkCE;EACE,eAAA;AAhCJ;AAkCI;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAhCN;AAoCE;EACE,kBAAA;AAlCJ;AAoCI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;EACA,YAAA;AAlCN;AAqCI;EACE,cAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;AAnCN;AAuCE;EACE,iBAAA;AArCJ;AAwCE;EACE,iBAAA;EACA,gBAAA;AAtCJ","sourcesContent":[".VideoCard {\n  cursor: pointer;\n  position: relative;\n\n  .VideoCard-image {\n    position: relative;\n    margin: 0 0 8px;\n\n    &.tooltipped::before {\n      top: 130px;\n    }\n\n    &.tooltipped::after {\n      top: 136px;\n    }\n\n    .VideoCard-live-ads-badges-with-remove {\n      top: 7px !important;\n      right: 31px !important;\n    }\n\n    .VideoCard-live-ads-badges-wrapper {\n      display: flex;\n      position: absolute;\n      z-index: 1;\n      top: 8px;\n      right: 8px;\n\n      .LivePostTag {\n        margin-left: 5px;\n      }\n\n      .YellowBadge-customStyle {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        svg {\n          path {\n            transform: translateX(20%);\n          }\n        }\n      }\n    }\n\n    .thumbnail-component-container {\n      overflow: hidden;\n      border-radius: 8px;\n      height: 173px;\n      background-color: var(--gray_insights3);\n\n      img {\n        display: block;\n        object-fit: cover;\n        transition: all 0.5s ease;\n\n        filter: brightness(80%);\n\n        &:hover {\n          filter: unset;\n        }\n      }\n    }\n\n    .checkbox {\n      position: absolute;\n      z-index: 1;\n      top: 8px;\n      left: 8px;\n      display: none;\n    }\n\n    div.checkbox[class*='dist_checked'] {\n      display: flex;\n    }\n\n    &:hover {\n      .checkbox {\n        display: flex;\n      }\n\n      .remove-video {\n        display: block;\n      }\n    }\n\n    > .remove-video {\n      position: absolute;\n      z-index: 1;\n      top: 8px;\n      right: 8px;\n      display: none;\n\n      svg {\n        path {\n          fill: var(--base_color1);\n        }\n      }\n    }\n  }\n\n  .VideoCard-provider {\n    position: absolute;\n    z-index: 1;\n    bottom: 8px;\n    right: 8px;\n    height: 24px;\n    width: 24px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    [class^='dist_providerIcon'] {\n      padding: 4px 4px;\n      border: 1px solid var(--base_color2);\n    }\n  }\n\n  .VideoCard-info-grid {\n    position: relative;\n    display: grid;\n    grid-template-columns: 40px minmax(0, 1fr) auto auto;\n    grid-column-gap: 8px;\n  }\n\n  .VideoCard-creator-thumb {\n    border-radius: 100%;\n    border: 1px solid var(--gray_light2);\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: block;\n    overflow: hidden;\n  }\n\n  .VideoCard-title {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n\n    color: var(--primary_dark2);\n    margin: 0 0 12px;\n    line-height: 20px;\n    font-size: 14px;\n  }\n\n  .CreatorCardOnHover {\n    position: initial;\n\n    .CreatorCardOnHover-popover {\n      top: auto;\n      bottom: 95%;\n      width: calc(100% - 16px);\n      left: 8px;\n      padding: 0 0 8px;\n    }\n  }\n\n  .VideoCard-publishedAt {\n    font-size: 10px;\n    color: var(--gray_dark1);\n    line-height: 15px;\n  }\n\n  .VideoCard-TopicListSmall {\n    margin: 7px 0 0;\n\n    h6 {\n      text-overflow: ellipsis;\n      overflow: hidden;\n      max-width: 150px;\n      white-space: nowrap;\n    }\n  }\n\n  .VideoCard-numbers {\n    text-align: center;\n\n    strong {\n      display: block;\n      font-weight: 600;\n      font-size: 12px;\n      color: var(--gray_dark2);\n      line-height: 20px;\n      height: 20px;\n    }\n\n    span {\n      display: block;\n      font-size: 12px;\n      color: var(--gray_dark1);\n      line-height: 15px;\n    }\n  }\n\n  .VideoCard-views {\n    margin: 0 4px 0 0;\n  }\n\n  .VideoCard-info {\n    min-height: 109px;\n    padding: 0px 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
